import { render, staticRenderFns } from "./UpdateWheelLockCarPark.vue?vue&type=template&id=651fab01&"
import script from "./UpdateWheelLockCarPark.vue?vue&type=script&lang=js&"
export * from "./UpdateWheelLockCarPark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports